<template>
  <span
    :class="[props.icon, props.iconColor, props.iconSize]"
    class="transition-colors duration-200 ease-in-out"
  ></span>
</template>
<script setup lang="ts">
//Iconlist
//https://icon-sets.iconify.design/mingcute

import type { IconColor, IconName } from '@therame/design-tokens';

export type IconSize = 'size-3' | 'size-4.5' | 'size-5' | 'size-6' | 'size-8' | 'size-16';

export interface GenericIconProps {
  icon: IconName;
  iconColor?: IconColor;
  iconSize?: IconSize;
}

const props = withDefaults(defineProps<GenericIconProps>(), {
  icon: undefined,
  iconColor: undefined,
  iconSize: 'size-4.5',
});
</script>
